import { inject, injectable } from 'inversify'
import { computed, makeObservable } from 'mobx'
import { Router } from '@core/routing/router'
import { I18nRepository } from '@core/infra/i18n/i18n.repository'

@injectable()
export class NotFoundPagePresenter {
  @inject(Router)
  private router!: Router

  @inject(I18nRepository)
  private i18nRepository!: I18nRepository

  constructor() {
    makeObservable(this, { viewModel: computed })
  }

  get viewModel() {
    return {
      title: this.i18nRepository.t('notFound.title'),
      body: this.i18nRepository.t('notFound.body'),
      goHomeLabel: this.i18nRepository.t('notFound.goHome'),
    }
  }

  goHome = () => {
    return this.router.goToId('Home')
  }
}
